module.exports = __webpack_public_path__ + "static/img/logo.19b9036.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/seoulone/logo.png
// module id = wfe7
// module chunks = 1